import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import 'hammerjs';
import { GalleryService } from '../../services/gallery.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { Album } from '../../models/album';
import { Subscription, combineLatest } from 'rxjs';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-albums',
  templateUrl: './albums.component.html',
  styleUrls: ['./albums.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlbumsComponent extends ComponentBase implements OnInit {

  constructor(
    private gallerService: GalleryService,
    private pageHeadingService: PageHeadingService,
    private renderer: Renderer2) {
    super();
  }

  galleryOptions: NgxGalleryOptions[] = [
    {
      'previewCloseOnEsc': true,
      'previewKeyboardNavigation': true,
      'arrowPrevIcon': 'fa fa-arrow-circle-left',
      'arrowNextIcon': 'fa fa-arrow-circle-right',
      'closeIcon': 'fa fa-times-circle',
      'imageSwipe': true,
      'previewArrowsAutoHide': true,
      'previewSwipe': true,
      'previewZoom': true,
      'previewRotate': true,
      'zoomInIcon': 'fa fa-search-plus',
      'zoomOutIcon': 'fa fa-search-minus',
      'rotateLeftIcon': 'fa fa-undo',
      'rotateRightIcon': 'fa fa-repeat',
      width: '200px',
      height: '200px',
      thumbnailsColumns: 4,
      imageAnimation: NgxGalleryAnimation.Slide
    }
  ];

  subscription: Subscription;
  albums: Array<Album>;
  gallery: NgxGalleryImage[] = [];
  fileUrls = [];
  imgUrls = [];
  tempArr = [];
  loading = true;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {

    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Gallery"));

    this.gallerService.getAlbums().subscribe(
      data => {
        this.loading = false;
        this.albums = data;

        for (var i = 0; i < this.albums.length; i++) {

          if (this.albums[i].file_url != null) {
            this.fileUrls = this.albums[i].file_url.split(',');

            for (var j = 0; j < this.fileUrls.length; j++) {
              this.tempArr.push({
                small: this.fileUrls[j],
                medium: this.fileUrls[j],
                big: this.fileUrls[j],
                description: this.albums[i].title
              })
            }

            this.imgUrls.push(this.tempArr)
            this.tempArr = [];
          }

        }
        this.gallery = this.imgUrls;
      }
    )

  }

  previewOpened() {
    this.renderer.addClass(document.body, "second-page");
    this.renderer.addClass(document.body, "gallery-popup-opened");
  }

  previewClosed() {
    this.renderer.removeClass(document.body, "second-page");
    this.renderer.removeClass(document.body, "gallery-popup-opened");
  }

}
